<template>
  <div id="uyh-loader">
    <svg width="118px" height="30px" viewBox="0 0 118 30" class="uyh-loader-gif">
      <path id="path1" d="M9.54782609,29.9932919 L9.54782609,29.550559 C9.54782609,28.5510559 9.86310559,27.6365217 10.9945342,25.4877019 L13.7962733,20.186087 L13.1098137,19.8529193 C11.9962733,21.4807453 10.1783851,24.4859627 6.35925466,24.4837267 C2.61167702,24.4814907 0,21.5344099 0,17.6392547 C0.00223602484,13.9296894 2.63850932,11.0765217 6.06857143,8.24124224 L15.4531677,0.437515528 L15.8243478,0.437515528 L25.204472,8.24795031 C28.6345342,11.0854658 31.3021118,13.9073292 31.2998758,17.6146584 C31.2976398,21.5075776 28.6501863,24.4926708 24.9026087,24.4926708 C21.0812422,24.4904348 19.261118,21.4852174 18.1498137,19.8551553 L17.4678261,20.186087 L20.2650932,25.4921739 C21.3942857,27.6409938 21.7095652,28.555528 21.7095652,29.5550311 L21.7095652,30 L9.54782609,29.9932919" fill="#FC7CA0" transform="translate(0.000000, 0.000000)"></path>
      <path id="path2" d="M9.54782609,29.9932919 L9.54782609,29.550559 C9.54782609,28.5510559 9.86310559,27.6365217 10.9945342,25.4877019 L13.7962733,20.186087 L13.1098137,19.8529193 C11.9962733,21.4807453 10.1783851,24.4859627 6.35925466,24.4837267 C2.61167702,24.4814907 0,21.5344099 0,17.6392547 C0.00223602484,13.9296894 2.63850932,11.0765217 6.06857143,8.24124224 L15.4531677,0.437515528 L15.8243478,0.437515528 L25.204472,8.24795031 C28.6345342,11.0854658 31.3021118,13.9073292 31.2998758,17.6146584 C31.2976398,21.5075776 28.6501863,24.4926708 24.9026087,24.4926708 C21.0812422,24.4904348 19.261118,21.4852174 18.1498137,19.8551553 L17.4678261,20.186087 L20.2650932,25.4921739 C21.3942857,27.6409938 21.7095652,28.555528 21.7095652,29.5550311 L21.7095652,30 L9.54782609,29.9932919" fill="#FC7CA0" transform="translate(43.000000, 0.000000)"></path>
      <path id="path3" d="M9.54782609,29.9932919 L9.54782609,29.550559 C9.54782609,28.5510559 9.86310559,27.6365217 10.9945342,25.4877019 L13.7962733,20.186087 L13.1098137,19.8529193 C11.9962733,21.4807453 10.1783851,24.4859627 6.35925466,24.4837267 C2.61167702,24.4814907 0,21.5344099 0,17.6392547 C0.00223602484,13.9296894 2.63850932,11.0765217 6.06857143,8.24124224 L15.4531677,0.437515528 L15.8243478,0.437515528 L25.204472,8.24795031 C28.6345342,11.0854658 31.3021118,13.9073292 31.2998758,17.6146584 C31.2976398,21.5075776 28.6501863,24.4926708 24.9026087,24.4926708 C21.0812422,24.4904348 19.261118,21.4852174 18.1498137,19.8551553 L17.4678261,20.186087 L20.2650932,25.4921739 C21.3942857,27.6409938 21.7095652,28.555528 21.7095652,29.5550311 L21.7095652,30 L9.54782609,29.9932919" fill="#FC7CA0" transform="translate(86.000000, 0.000000)"></path>
  </svg>
  </div>
</template>

<script>
  export default {
    name: 'loader'
  }
</script>

<style scoped lang="scss">
  $light-pink: #F8BACA;
  $dark-pink: #FC7CA0;
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    #uyh-loader {
      background-color: rgba(0,0,0,0.75);
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 20;
      .uyh-loader-gif {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 125px;
        
        #path1 {
          -webkit-animation: loader1 1.5s infinite alternate;
          -moz-animation: loader1 1.5s infinite alternate;
          -o-animation: loader1 1.5s infinite alternate;
          animation: loader1 1.5s infinite alternate;
        }
        #path2 {
          -webkit-animation: loader2 1.5s infinite alternate;
          -moz-animation: loader2 1.5s infinite alternate;
          -o-animation: loader2 1.5s infinite alternate;
          animation: loader2 1.5s infinite alternate;
        }
        #path3 {
          -webkit-animation: loader3 1.5s infinite alternate;
          -moz-animation: loader3 1.5s infinite alternate;
          -o-animation: loader3 1.5s infinite alternate;
          animation: loader3 1.5s infinite alternate;
        }

        @keyframes loader1 {
          0% { 
            fill: $light-pink;
          }
          24% {
            fill: $light-pink;
          }
          25% {
            fill: $dark-pink;
          }
          100% {
            fill: $dark-pink;
          }
        }

        @keyframes loader2 {
          0% { 
            fill: $light-pink;
          }
          49% {
            fill: $light-pink;
          }
          50% {
            fill: $dark-pink;
          }
          100% {
            fill: $dark-pink;
          }
        }

        @keyframes loader3 {
          0% { 
            fill: $light-pink;
          }
          74% {
            fill: $light-pink;
          }
          75% {
            fill: $dark-pink;
          }
          100% {
            fill: $dark-pink;
          }
        }

      }
    }
  }
</style>